import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(theme => ({
  thumbArrow: {
    '&:first-child': {
      transform: 'rotate(180deg)',
    },
    color: theme.palette.common.blue400,
    fill: 'currentColor',
  },
}));

export default useStyles;
